import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Textarea } from "../../components/ui/textarea";

export function CheckOutTab({
  displayName, getCheckedInStudents, getStudentScheduledTime,
  onTimeCheckouts, setOnTimeCheckouts, earlyStudent, setEarlyStudent,
  earlyTime, setEarlyTime, earlyPlanned, setEarlyPlanned,
  earlyNotes, setEarlyNotes, handleBulkCheckOut, handleEarlyDismissal,
}) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>On-Time Departures</CardTitle>
          <CardDescription>Select dismissal type to record check-outs</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
            {getCheckedInStudents().map((student) => {
              const schedTime = getStudentScheduledTime(student, 'end');
              const isCustomTime = schedTime !== "14:00" && schedTime !== "12:00";
              return (
                <div key={student.id} className="flex items-center space-x-3 p-3 rounded-lg border hover:bg-muted/50 transition-colors">
                  <Checkbox
                    id={`checkout-${student.id}`}
                    checked={onTimeCheckouts[student.id] || false}
                    onCheckedChange={(checked) =>
                      setOnTimeCheckouts((prev) => ({ ...prev, [student.id]: checked }))
                    }
                    data-testid={`checkout-checkbox-${student.id}`}
                  />
                  <Label htmlFor={`checkout-${student.id}`} className="cursor-pointer">
                    {displayName(student)} {student.last_name}
                    {isCustomTime && (
                      <span className="block text-xs text-blue-600 font-normal">Departs: {schedTime}</span>
                    )}
                  </Label>
                </div>
              );
            })}
          </div>
          {getCheckedInStudents().length === 0 && (
            <p className="text-muted-foreground text-center py-4">No students to check out</p>
          )}
          <div className="flex gap-3">
            <Button
              onClick={() => handleBulkCheckOut(false)}
              className="bg-[#00305E] hover:bg-[#00305E]/90"
              disabled={Object.values(onTimeCheckouts).filter(Boolean).length === 0}
              data-testid="checkout-btn"
            >
              Check Out at Scheduled Time
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Early Dismissal / Alternate Plan</CardTitle>
          <CardDescription>Record early departures with timestamp</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Student</Label>
              <Select value={earlyStudent} onValueChange={setEarlyStudent}>
                <SelectTrigger data-testid="early-student-select"><SelectValue placeholder="Select student" /></SelectTrigger>
                <SelectContent>
                  {getCheckedInStudents().map((student) => (
                    <SelectItem key={student.id} value={student.id}>
                      {displayName(student)} {student.last_name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Departure Time (leave blank for current time)</Label>
              <Input type="time" value={earlyTime} onChange={(e) => setEarlyTime(e.target.value)} data-testid="early-time-input" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Type</Label>
            <Select value={earlyPlanned ? "planned" : "unplanned"} onValueChange={(v) => setEarlyPlanned(v === "planned")}>
              <SelectTrigger data-testid="early-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="planned">Planned</SelectItem>
                <SelectItem value="unplanned">Unplanned</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Textarea placeholder="Add any notes..." value={earlyNotes} onChange={(e) => setEarlyNotes(e.target.value)} data-testid="early-notes" />
          </div>
          <Button onClick={handleEarlyDismissal} className="bg-amber-600 hover:bg-amber-700" data-testid="early-dismissal-btn">
            Record Early Dismissal
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
